/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ expected: NonNullable<unknown>, current: NonNullable<unknown> }} Err_Tournament_Wrong_StateInputs */



/**
* | output |
* | --- |
* | "Tournament must be in {expected} state (currently {current})" |
*
* @param {Err_Tournament_Wrong_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_wrong_state = /** @type {((inputs: Err_Tournament_Wrong_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Wrong_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le tournoi doit être dans l'état ${i?.expected} (actuellement ${i?.current})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El torneo debe estar en estado ${i?.expected} (actualmente ${i?.current})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O torneio deve estar no estado ${i?.expected} (atualmente ${i?.current})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il torneo deve essere nello stato ${i?.expected} (attualmente ${i?.current})`)
	return /** @type {LocalizedString} */ (`Tournament must be in ${i?.expected} state (currently ${i?.current})`)
});